"use client";

export default function AboutPage() {
  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        background: "var(--color-bg-about)",
      }}
    >
      {/* Map background image */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url("/about-bg.png")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 0.25,
        }}
      />

      {/* Content card */}
      <div
        style={{
          position: "relative",
          zIndex: 1,
          maxWidth: 480,
          width: "calc(100% - 3rem)",
          margin: "1rem",
          padding: "clamp(1.25rem, 4vw, 2rem) clamp(1rem, 3vw, 1.75rem)",
          background: "var(--color-bg-about-card)",
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          borderRadius: 12,
          border: "1px solid rgba(0, 0, 0, 0.08)",
          boxShadow: "0 4px 24px rgba(0, 0, 0, 0.06)",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: "1.3rem",
            fontWeight: 600,
            color: "var(--color-text)",
            marginBottom: "0.5rem",
            letterSpacing: "-0.02em",
          }}
        >
          Occum
        </h1>
        <div
          style={{
            width: 40,
            height: 1,
            background: "var(--color-border-secondary)",
            margin: "0 auto 1rem",
          }}
        />
        <p
          style={{
            fontSize: "0.82rem",
            lineHeight: 1.7,
            color: "var(--color-text-about)",
          }}
        >
          Named after{" "}
          <a
            href="https://en.wikipedia.org/wiki/Samson_Occom"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
          >
            Samson Occom
          </a>
          , this was another mill town that was later incorporated into Norwich.
          Like Greeneville, it is located on the Shetucket River. The old mill
          has since been demolished. Occum contains a small business center with
          a fire station and public park. The rest is devoted to residential
          housing and churches extending into{" "}
          <a
            href="https://en.wikipedia.org/wiki/Baltic,_Connecticut"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
          >
            Baltic
          </a>
          .
        </p>
      </div>
    </div>
  );
}

const linkStyle: React.CSSProperties = {
  color: "var(--color-accent-about)",
  textDecoration: "underline",
  textUnderlineOffset: "2px",
};
